export const NO_INTERPOLATION_ESCAPE = { escapeValue: false };
export const NO_ESCAPE_OPTIONS = { interpolation: NO_INTERPOLATION_ESCAPE };
